import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";

const KEY = "rubipos_caja_sucursal";
export const ROLES_MULTI = ["gran_admin", "coordinador"];

// Sucursal cuya caja se opera: fija para usuarios de sucursal, seleccionable (y recordada) para admin/coordinador.
export default function useSucursalCaja(sucursales = []) {
  const { user } = useAuth();
  const multi = ROLES_MULTI.includes(user?.rol);
  const [sel, setSel] = useState(() => localStorage.getItem(KEY) || "");
  useEffect(() => {
    if (multi && sel && sucursales.length && !sucursales.some((s) => s.id === sel)) { setSel(""); localStorage.removeItem(KEY); }
  }, [multi, sel, sucursales]);
  const setSucursal = (id) => { setSel(id); if (id) localStorage.setItem(KEY, id); else localStorage.removeItem(KEY); };
  const sucursalId = multi ? sel : user?.sucursal_id || "";
  return { sucursalId, setSucursal, multi, sucursal: sucursales.find((s) => s.id === sucursalId) || null };
}
